import { Skeleton } from "@mui/material";
import React from "react";

const ModalPreloader = () => {
 return (
  <div width="100%"> 
    {[
     1, 2, 3, 4,5,6,7,8,9,10,11,12,13,14,15
    ].map((item) => {
     return (
      <div key={item} > {/* Add key prop and style */}
       <Skeleton
        animation={"wave"}
        // variant = "rectangular"
       />
      </div>
     );
    })}
  </div>
 );
};

export default ModalPreloader;
